<template>
    <div>
        <div class="menu-title">
            线上模型管理
        </div>
        <div class="menu-content">
            <div>
                <el-form  :inline="true" :model="qo" size="small" class="demo-form-inline">
                  <el-form-item label="模型名称：">
                    <el-input v-model="qo.LIKES_name" placeholder="请输入模型名称" style="width: 300px"></el-input>
                  </el-form-item>
                  <el-form-item >
                    <el-button type="success" icon="el-icon-search" @click="qo.pageNo=1;queryData()">搜 索</el-button>
                  </el-form-item>
                </el-form>
            </div>
            <div style="margin: 0px 0 20px 0">
                <el-button type="primary" icon="el-icon-plus" size="small" @click="createRow()">添加</el-button>
            </div>
            <div class="table-list">
                <el-table :data="result.records" style="width: 100%" >
                    <el-table-column type="index" label="序号" width="100" ></el-table-column>
                    <el-table-column label="Logo" width="150">
                      <template slot-scope="scope" >
                        <el-image v-if="scope.row.logoUrl != null && scope.row.logoUrl.length > 0"
                                  style="width: 70px; height: 70px;background-color: #b0b4b9;"
                                  :src="path+scope.row.logoUrl"
                                  :preview-src-list="[path+scope.row.logoUrl]"
                                  fit="contain"></el-image>
                      </template>
                    </el-table-column>
                    <el-table-column prop="name" label="模型名称" ></el-table-column>
                    <el-table-column label="平台" prop="platform"></el-table-column>
                    <el-table-column prop="model" label="模型" ></el-table-column>
                    <el-table-column prop="effect" label="记忆力" width="150"></el-table-column>
                    <el-table-column prop="score" label="综合评分" ></el-table-column>
                    <el-table-column label="类型">
                        <template slot-scope="scope" >
                          {{formatType(scope.row.type)}}
                        </template>
                      </el-table-column>
                    <el-table-column prop="name" label="状态" >
                      <template slot-scope="scope">
                        {{scope.row.status?"启用":"未启用"}}
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="160">
                        <template slot-scope="scope">
                            <el-button @click.native.prevent="statusRow(scope.row)"  type="text" size="small">
                              {{scope.row.status?"禁用":"启用"}}
                            </el-button>
                            <el-button @click.native.prevent="modifyRow(scope.row)"  type="text" size="small">
                                编辑
                            </el-button>
                            <el-button @click.native.prevent="removeRow(scope.row)"  type="text" size="small">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page-box">
                <el-pagination background
                               @current-change="handleCurrentChange"
                               :current-page="qo.pageNo"
                               :page-size="qo.pageSize"
                               :page-sizes="[10,20,30,40,50]" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next"
                               :total="result.total">
                </el-pagination>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false"
                :title="dialogName"
                :visible.sync="cmdDialogVisible"
                width="40%">
            <el-form ref="cmd" label-width="80px" :rules="rules" :model="cmd">
                <el-form-item label="模型名称" prop="label">
                    <el-input v-model="cmd.name" placeholder="请输入模型名称"></el-input>
                </el-form-item>
                <el-form-item label="平台" prop="platform">
                  <el-select v-model="cmd.platform" style="width: 100%" placeholder="请选择平台" @change="changePlatform">
                    <el-option :value="item.value" :label="item.name" v-for="item in platforms"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="模型" prop="model">
                  <el-select v-if="isOpenrouter" v-model="cmd.model" style="width: 100%" filterable placeholder="请选择模型"  @change="changeModel">
                    <el-option :value="item.id" :label="item.id" v-for="item in models"></el-option>
                  </el-select>
                  <el-input v-else v-model="cmd.model" placeholder="请输入模型"></el-input>
                </el-form-item>
                <el-form-item label="记忆力" prop="effect">
                  <el-select v-model="cmd.effect" placeholder="请选择记忆力" style="width: 100%">
                    <el-option v-for="item in memoryList" :value="item.name" :label="item.name"></el-option>
                  </el-select>
                </el-form-item>
              <el-form-item label="综合评分" prop="score">
                <el-input v-model.number="cmd.score" placeholder="请输入综合评分" ></el-input>
              </el-form-item>
                <el-form-item label="类型" prop="type">
                  <el-select v-model="cmd.type" style="width: 100%" placeholder="请选择类型">
                    <el-option :value="item.value" :label="item.name" v-for="item in modelTypes"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="格式预设" prop="formatPresetId">
                  <el-select v-model="cmd.formatPresetId" style="width: 100%" placeholder="请选择格式预设">
                    <el-option :value="item.id" :label="item.name" v-for="item in presetsList" v-if="item.type == 1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="模式预设" prop="modePresetId">
                  <el-select v-model="cmd.modePresetId" style="width: 100%" placeholder="请选择模式预设">
                    <el-option :value="item.id" :label="item.name" v-for="item in presetsList"  v-if="item.type == 2 && item.modelType == 'online'"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="多模态" prop="multimodalArray">
                  <el-select v-model="cmd.multimodalArray" multiple placeholder="请选择" style="width: 100%">
                    <el-option label="文本" value="文本"></el-option>
                    <el-option label="图片" value="图片"></el-option>
                    <el-option label="语音" value="语音"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="描述" prop="description">
                  <el-input v-model="cmd.description" placeholder="请输入描述" type="textarea" :rows="5"></el-input>
                </el-form-item>
                <el-form-item label="Logo" >
                  <el-upload
                      class="avatar-uploader"
                      action="#"
                      :on-change="handleFileChange"
                      :auto-upload="false"
                      :show-file-list="false">
                    <img v-if="imageUrl" :src="imageUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cmdDialogVisible = false"  size="small">取 消</el-button>
                <el-button type="primary" @click="submitModify"  size="small">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import request, {getFileUrl} from '@/utils/request';
import axios from "axios";
import {getMemoryList, memoryList} from "@/utils/common";

    var _this;
    export default {
        name: "unitManage",
        data() {
            return {
                qo: {
                    pageNo: 1,
                    pageSize: 10,
                    LIKES_name: '',
                    DESCI_createTime:1,
                },
                result: {
                    records: [],
                    total: 0
                },
                dialogName: '编辑',
                cmdDialogVisible: false,
                cmd: {},
                rules: {
                    sorce:[
                      { type: 'number', message: '综合评分必须为数字值'}
                    ],
                    minMemory:[
                      { type: 'number', message: '最小内存必须为数字值'}
                    ],
                    minVram:[
                      { type: 'number', message: '最小必须为数字值'}
                    ],
                },
                imageUrl:"",
                path:getFileUrl(),
                modelTypes:[],
                platforms:[],
                models:[],
                presetsList:[],
                memoryList:getMemoryList()
            }
        },
      computed: {
        isOpenrouter() {
          return !this.cmd.platform || this.cmd.platform === 'openrouter';
        }
      },
      created() {
        _this = this;
        _this.queryModelType()
        _this.queryPlatform()
        _this.queryModel()
        _this.queryPreset()
      },
      mounted() {
            _this.queryData();
        },
        methods: {
            queryData() {
                request({
                    url: '/public/online-model/query_pages',
                    method: 'post',
                    data: _this.qo
                }).then(res => {
                    _this.result.records = res.records;
                    _this.result.total = res.total;
                });
            },
            queryPreset(){
              request({
                url: '/public/presets/query_list',
                method: 'post',
                data: {}
              }).then(res => {
                _this.presetsList = res;
              });
            },
            queryModelType() {
                request({
                  url: '/public/dictionary/query_list',
                  method: 'post',
                  data: {EQS_label:'model_type'}
                  }).then(res => {
                    _this.modelTypes = res;
                  });
            },
            queryPlatform() {
                request({
                  url: '/public/dictionary/query_list',
                  method: 'post',
                  data: {EQS_label:'platform'}
                  }).then(res => {
                    _this.platforms = res;
                  });
            },
            changePlatform() {
                this.cmd.model = "";
            },
            queryModel(){
              axios.get("https://openrouter.ai/api/v1/models").
              then(res => {
                _this.models = res.data.data || []
                console.log(res)
              })
            },
            changeModel(){
              let modelLen = 0
              this.models.forEach(item => {
                if(item.id == this.cmd.model){
                  modelLen = item.context_length
                }
              })
              console.log(modelLen)
              this.memoryList.forEach(item => {
                if(item.min && item.max && item.min <= modelLen && item.max > modelLen){
                  this.cmd.effect = item.name
                }else if(item.min && !item.max && modelLen >= item.min){
                  this.cmd.effect = item.name
                }else if(!item.min && item.max && modelLen < item.max){
                  this.cmd.effect = item.name
                }
              })

            },
            handleCurrentChange(val) {
                _this.qo.pageNo = val;
                _this.queryData();
            },
            handleSizeChange(val) {
                _this.qo.pageNo = 1;
                _this.qo.pageSize = val;
                _this.queryData();
            },
            removeRow(item) {
                _this.$confirm('此操作将永久删除记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    request({
                        url: '/public/online-model/remove/' + item.id,
                        method: 'post'
                    }).then(res => {
                        _this.$message.success("删除成功");
                        _this.queryData();
                    });
                }).catch(() => {
                });
            },
            createRow() {
                _this.dialogName = '添加';
                _this.imageUrl = ""
                _this.cmdDialogVisible = true;
                _this.$nextTick(() => {
                    _this.cmd = {
                        platform: "openrouter",
                        model: "",
                        name:"",
                        logoUrl:"",
                        description:"",
                        type:"",
                        formatPresetId:"",
                        formatPresetName:"",
                        modePresetId:"",
                        modePresetName:"",
                        score:"",
                        multimodalArray:['文本'],
                        multimodal:""
                    };
                    _this.presetsList.forEach(item => {
                      if(item.type == 1 && item.isSelect){
                        _this.cmd.formatPresetId = item.id
                        _this.cmd.formatPresetName = item.name
                      }
                      if(item.type == 2 && item.modelType == 'online' && item.isSelect){
                        _this.cmd.modePresetId = item.id
                        _this.cmd.modePresetName = item.name
                      }
                    })
                    _this.$refs.cmd.resetFields();
                });
            },
            modifyRow(item) {
                _this.dialogName = '编辑';
                _this.imageUrl = ""
                _this.cmdDialogVisible = true;
                _this.$nextTick(() => {
                    if(item.logoUrl){
                      _this.imageUrl = _this.path + item.logoUrl;
                    }else{
                      _this.imageUrl = ""
                    }
                    if(item.multimodal){
                      item.multimodalArray = item.multimodal.split(",")
                    }else{
                      item.multimodalArray = []
                    }
                    _this.cmd = JSON.parse(JSON.stringify(item));

                    console.log(_this.cmd)
                    _this.$refs.cmd.resetFields();
                });
            },
            statusRow(item) {
              _this.$confirm('此操作将'+(item.status?'禁用':'启用')+', 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                let param = JSON.parse(JSON.stringify(item))
                param.status = !param.status
                request({
                  url: '/public/online-model/modify',
                  method: 'post',
                  data: param
                }).then(res => {
                  _this.$message.success((item.status?'禁用':'启用')+"成功");
                  _this.queryData();
                });
              }).catch(() => {
              });
            },
            submitModify() {
                this.$refs.cmd.validate((valid) => {
                    if (valid) {
                        if(_this.cmd.formatPresetId){
                          this.presetsList.forEach(item => {
                            if(item.id == _this.cmd.formatPresetId){
                              _this.cmd.formatPresetName = item.name
                            }
                          })
                        }
                        if(_this.cmd.modePresetId){
                          this.presetsList.forEach(item => {
                            if(item.id == _this.cmd.modePresetId){
                              _this.cmd.modePresetName = item.name
                            }
                          })
                        }
                        if(_this.cmd.multimodalArray && _this.cmd.multimodalArray.length > 0){
                          _this.cmd.multimodal = _this.cmd.multimodalArray.join(",")
                        }else{
                          _this.cmd.multimodal = ""
                        }
                        if (_this.cmd.id && _this.cmd.id.toString.length > 0) {
                            request({
                                url: '/public/online-model/modify',
                                method: 'post',
                                data: _this.cmd
                            }).then(res => {
                                _this.$message.success("编辑成功");
                                _this.cmdDialogVisible = false;
                                _this.queryData();
                            });
                        } else {
                            request({
                                url: '/public/online-model/create',
                                method: 'post',
                                data: _this.cmd
                            }).then(res => {
                                _this.$message.success("添加成功");
                                _this.cmdDialogVisible = false;
                                _this.queryData();
                            });
                        }
                    }
                });
            },
            handleFileChange(file, fileList) {
              this.imageUrl = URL.createObjectURL(file.raw);
              let formData = new FormData();
              formData.append("file", file.raw);
              request({
                url: '/upload/file/logo',
                method: 'post',
                data: formData
              }).then(res => {
                _this.$set(_this.cmd, "logoUrl", res)
              });
            },
            formatType(value){
                let str = ""
                this.modelTypes.forEach(item => {
                  if(value == item.value){
                    str = item.name
                  }
                })

                return str
            },
            formatPlatform(value){
                if(!value){
                    value = 'openrouter'
                }
                let str = ""
                this.platforms.forEach(item => {
                  if(value == item.value){
                    str = item.name
                  }
                })

                if(!str){
                  str = value
                }
                return str
            }
        }
    }
</script>

<style  lang="scss">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
